import { useEffect, useRef, useState } from 'react';
import './App.scss';
import Header from './components/Header';
import Home from './pages/Home';
import Footer from './components/Footer';
import ScrollWidget from './components/ScrollWidget';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Booking from './pages/Booking';
import AOS from 'aos';
import 'aos/dist/aos.css';
import React from 'react';
import { DEFAULT_BOOKING_URL, ROUTES } from './utils/constants';
import { Helmet } from 'react-helmet';
import { metadataConfig } from './utils/metadata';

function AppContent() {
  const homeRef = useRef<HTMLDivElement>(null);
  const whoWeAreRef = useRef<HTMLDivElement>(null);
  const featuresRef = useRef<HTMLDivElement>(null);
  const analyticsRef = useRef<HTMLDivElement>(null);
  const serviceRef = useRef<HTMLDivElement>(null);
  const testimonialsRef = useRef<HTMLDivElement>(null);
  const faqsRef = useRef<HTMLDivElement>(null);
  const [isWidgetVisible, setIsWidgetVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1026);
  const location = useLocation();
  const isFtcPage = location.pathname.includes('ftc');
  const isBookingPage = location.pathname.includes('booking');
  const metadata = isFtcPage 
    ? metadataConfig.ftc 
    : isBookingPage 
    ? metadataConfig.booking 
    : metadataConfig.default;

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1026);
    };

    window.scrollTo(0, 0);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.defer = true;
    script.src =
      "//cdn.mouseflow.com/projects/41f185f4-af18-4248-b5d0-3ade128889b4.js";
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition =
        (window.scrollY / document.documentElement.scrollHeight) * 100;

      if (scrollPosition > 30) {
        setIsWidgetVisible(true);
      } else {
        setIsWidgetVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const commonElement = (
    <>
      <Header
        homeRef={homeRef}
        whoWeAreRef={whoWeAreRef}
        featuresRef={featuresRef}
        serviceRef={serviceRef}
        analyticsRef={analyticsRef}
        testimonialsRef={testimonialsRef}
        faqsRef={faqsRef}
        isMobile={isMobile}
      />
      <Home
        homeRef={homeRef}
        whoWeAreRef={whoWeAreRef}
        featuresRef={featuresRef}
        serviceRef={serviceRef}
        analyticsRef={analyticsRef}
        testimonialsRef={testimonialsRef}
        faqsRef={faqsRef}
        isMobile={isMobile}
      />
      <Footer
        homeRef={homeRef}
        whoWeAreRef={whoWeAreRef}
        featuresRef={featuresRef}
        faqsRef={faqsRef}
        serviceRef={serviceRef}
        analyticsRef={analyticsRef}
        testimonialsRef={testimonialsRef}
        isMobile={isMobile}
      />
      {isWidgetVisible && <ScrollWidget />}
    </>
  );

  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
      </Helmet>
      <Routes>
        {ROUTES.map(({ path, bookingUrl }) => (
          <React.Fragment key={path}>
            <Route path={`/${path}`} element={commonElement} />
            <Route
              path={`/${path}/booking/*`}
              element={
                <Booking url={`https://meetings.hubspot.com/${bookingUrl}?embed=true`} />
              }
            />
          </React.Fragment>
        ))}

        <Route path="/" element={commonElement} />
        <Route
          path="/booking/*"
          element={
            <Booking url={`https://meetings.hubspot.com/${DEFAULT_BOOKING_URL}?embed=true`} />
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
